module.exports = __webpack_public_path__ + "img/20201204_115027.a5557c2b.jpg";